import axios from "axios";
import apiConfig from "./allApi";
import { getToken, logout, logoutIfTokenExpired } from "./authSession";

const instance = axios.create({
  baseURL: apiConfig.baseUrl,
});

const handleAuthError = (error) => {
  const errorStatus = error?.response?.status;

  // A request can pass `allowForbidden: true` in its config when a 403 means
  // "this user's role can't use this feature" rather than a bad session.
  const forbiddenAllowed =
    errorStatus === 403 && error?.config?.allowForbidden;

  if ((errorStatus === 401 || errorStatus === 403) && !forbiddenAllowed) {
    logout();
  }

  return Promise.reject(error);
};

const isLoginRequest = (config) => config?.url?.includes("/auth/login");

const addAuthToken = (config) => {
  if (config) {
    if (logoutIfTokenExpired() && !isLoginRequest(config)) {
      return Promise.reject(new Error("Session expired"));
    }

    const token = getToken();
    if (token && !isLoginRequest(config)) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  };

  return config;
};

instance.interceptors.request.use(
  addAuthToken,
  (error) => {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  (response) => {
    return response
},
 handleAuthError

)

axios.interceptors.response.use(
  (response) => response,
  handleAuthError
);

axios.interceptors.request.use(
  addAuthToken,
  (error) => Promise.reject(error)
);

export default instance;
